module.exports = __webpack_public_path__ + "arrow_black.svg?6958af487b8bb1f81d84c78f9148092c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map_icons/arrow_black.svg
// module id = 1357
// module chunks = 0